import React from 'react';
import { X, Download } from 'lucide-react';

const PdfViewerModal = ({ isOpen, onClose, url, title }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" 
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Modal Container */}
      <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl h-[90vh] flex flex-col z-10 overflow-hidden relative">
        
        {/* Header */}
        <div className="px-4 py-3 border-b flex justify-between items-center bg-gray-50 flex-none">
          <h3 className="text-lg font-medium text-gray-900 truncate pr-4">
            {title || 'Document Preview'}
          </h3>
          <div className="flex items-center space-x-2 shrink-0">
            <a 
              href={url} 
              download 
              target="_blank" 
              rel="noreferrer"
              className="text-gray-500 hover:text-indigo-600 p-2 rounded-full hover:bg-gray-200 transition-colors"
              title="Télécharger"
            >
              <Download className="w-5 h-5" />
            </a>
            <button
              onClick={onClose}
              type="button"
              className="text-gray-500 hover:text-red-600 p-2 rounded-full hover:bg-gray-200 transition-colors focus:outline-none"
              title="Fermer"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Content (Iframe) */}
        <div className="flex-1 bg-gray-100 relative w-full h-full">
           <iframe 
             src={url} 
             className="absolute inset-0 w-full h-full"
             title="PDF Preview"
             frameBorder="0"
           />
        </div>
      </div>
    </div>
  );
};

export default PdfViewerModal;
